import { render, staticRenderFns } from "./OfferTwoMonthDiscount.vue?vue&type=template&id=6f8f8a3f&scoped=true"
import script from "./OfferTwoMonthDiscount.vue?vue&type=script&lang=js"
export * from "./OfferTwoMonthDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8f8a3f",
  null
  
)

export default component.exports